import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Form, Select } from "semantic-ui-react";

import { ErrorWrap } from "../../../helpers/error";
import { EditEntity } from "../../../components/common/edit-entity";
import {
  clearError,
  createUser,
  updateUser,
} from "../../../redux/modules/user";
import {
  FormdataManager,
  getInitialState,
} from "../../../components/common/formdata";
import { UserFile } from "../../ticket/user-file";
import { fetchUserRoles } from "../../../redux/modules/user-role";
import { t } from "../../../constant/translations";

export const UserEditComponent = (props) => {
  const [formData, setFormData] = useState(null);

  const error = useSelector((state) => ErrorWrap.fromError(state.user.error));
  const loading = useSelector((state) => state.user.pending);
  const roles = useSelector((state) => state.userRole.entities || []);
  const dispatch = useDispatch();

  const initialState = getInitialState(props.entity, props.initialData);
  const manager = new FormdataManager(
    formData || initialState,
    setFormData,
    initialState
  ).withError(error);
  const header = props.entity
    ? t("management.user_change")
    : t("management.new_user");

  const handleCreate = (data) => dispatch(createUser(data));
  const handleUpdate = (data) => dispatch(updateUser(data));
  const handleFetchUserRoles = () => dispatch(fetchUserRoles());
  const handleClearError = () => dispatch(clearError());

  return (
    <EditEntity
      manager={manager}
      {...props}
      create={handleCreate}
      update={handleUpdate}
      clearError={handleClearError}
      error={error}
      loading={loading}
      header={header}
      trigger_props={{
        floated: "right",
      }}
    >
      <Form.Field>
        <label>{t("labels.name")}</label>
        <Form.Input
          placeholder={t("labels.name")}
          {...manager.getAttributes("first_name")}
        />
        {error.has("first_name") && <span>{error.get("first_name")}</span>}
      </Form.Field>
      <Form.Field>
        <label>{t("management.last_name")}</label>
        <Form.Input
          placeholder={t("management.last_name")}
          {...manager.getAttributes("last_name")}
        />
        {error.has("last_name") && <span>{error.get("last_name")}</span>}
      </Form.Field>
      <Form.Field>
        <label>Email</label>
        <Form.Input placeholder="Email" {...manager.getAttributes("email")} />
        {error.has("email") && <span>{error.get("email")}</span>}
      </Form.Field>
      <Form.Field>
        <label>{t("resources.user-role")}</label>
        <Select
          placeholder={t("management.select_role")}
          options={roles.map((role) => {
            return { key: role.name, value: role.name, text: role.name };
          })}
          {...manager.getAttributes("role_v2")}
        />
        {error.has("role_v2") && <span>{error.get("role_v2")}</span>}
      </Form.Field>
      <Form.Field>
        <UserFile
          name="profile_picture"
          accept="image/*"
          oneFile={true}
          {...manager.getAttributes("profile_picture")}
        />
      </Form.Field>
    </EditEntity>
  );
};

UserEditComponent.propTypes = {
  entity: PropTypes.object,
  initialData: PropTypes.object,
};

export const UserEdit = UserEditComponent;
